import { useForm } from '@/common/form/FormContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { ExprUtils } from '@/common/utils/ExprUtils';

// Wraps the default propId picker so its options stay scoped to the currently selected owner's entity type -
// needed because the owner (and therefore the applicable entity type) can change via EntityPropOwnerField.
export const EntityPropIdField = ({ fieldDef, propIdFilter }) => {
  const { formValues } = useForm();

  const entityExpr = ExprUtils.whereParams('entity', formValues.entity);
  const expr = propIdFilter ? ExprUtils.and(entityExpr, propIdFilter) : entityExpr;

  return <EntitySelect fieldDef={{ ...fieldDef, expr }} />;
};
